<template>
  <b-modal
    title="Editar Item da estrutura"
    ok-title="Salvar"
    cancel-title="Cancelar"
    ref="modal-edit"
    @ok="submit"
    @close="show_form = false"
  >
    <DadosBasicos ref="dados_basicos" v-if="show_form" />
  </b-modal>
</template>

<script>
import DadosBasicos from "../Form/DadosBasicos.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: { DadosBasicos },
  props: {
    item: {
      type: Object,
    },
  },
  data: () => ({
    show_form: false,
    validations: {
      dados_basicos: true,
    },
  }),
  computed: {
    ...mapState("organizational_structures", ["structure_item"]),
  },
  methods: {
    ...mapActions("organizational_structures", [
      "ActionShow",
      "ActionNew",
      "ActionSave",
      "ActionTreeStructure",
    ]),
    async submit(evt) {
      evt.preventDefault();

      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
      } else {
        try {
          await this.ActionSave(this.structure_item);
          this.ActionTreeStructure();

          this.$notifications.addNotification({
            message: "Registro salvo com sucesso",
            type: "success",
          });
          this.show_form = false;
          this.$refs["modal-edit"].hide();
        } catch (error) {
          console.log("ERROR", error);
        }
      }
    },
    isValid() {
      this.validations.dados_basicos = this.$refs.dados_basicos.isValid();
      return Object.values(this.validations).every(Boolean);
    },
    async show(item) {
      this.show_form = false;
      this.$refs["modal-edit"].show();
      if (item && item.id) {
        await this.ActionShow({ id: item.id });
      } else {
        await this.ActionNew();
      }
      this.show_form = true;
    },
  },
};
</script>

<style>
</style>
